import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "16",
  viewBox: "0 0 22 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Find-Friends" }, [
      _createElementVNode("g", { id: "Group" }, [
        _createElementVNode("path", {
          id: "Vector",
          d: "M4 11L3.4 10.5C1.4 8.6 0 7.4 0 5.9C0 4.7 1 3.7 2.2 3.7C2.9 3.7 3.6 4 4 4.5C4.4 4 5.1 3.7 5.8 3.7C7 3.7 8 4.6 8 5.9C8 7.4 6.6 8.6 4.6 10.5L4 11ZM14 0C12.9391 0 11.9217 0.421427 11.1716 1.17157C10.4214 1.92172 10 2.93913 10 4C10 5.06087 10.4214 6.07828 11.1716 6.82843C11.9217 7.57857 12.9391 8 14 8C15.0609 8 16.0783 7.57857 16.8284 6.82843C17.5786 6.07828 18 5.06087 18 4C18 2.93913 17.5786 1.92172 16.8284 1.17157C16.0783 0.421427 15.0609 0 14 0ZM14 6.1C13.443 6.1 12.9089 5.87875 12.5151 5.48492C12.1212 5.0911 11.9 4.55695 11.9 4C11.9 3.44305 12.1212 2.9089 12.5151 2.51508C12.9089 2.12125 13.443 1.9 14 1.9C14.2758 1.9 14.5489 1.95432 14.8036 2.05985C15.0584 2.16539 15.2899 2.32007 15.4849 2.51508C15.6799 2.71008 15.8346 2.94158 15.9401 3.19636C16.0457 3.45115 16.1 3.72422 16.1 4C16.1 4.27578 16.0457 4.54885 15.9401 4.80364C15.8346 5.05842 15.6799 5.28992 15.4849 5.48492C15.2899 5.67993 15.0584 5.83461 14.8036 5.94015C14.5489 6.04568 14.2758 6.1 14 6.1ZM14 9C11.33 9 6 10.33 6 13V16H22V13C22 10.33 16.67 9 14 9ZM20.1 14.1H7.9V13C7.9 12.36 11 10.9 14 10.9C16.97 10.9 20.1 12.36 20.1 13V14.1Z",
          fill: "currentColor"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }